import * as React from 'react';
import styled from 'styled-components';
import { FlexRowCenterVertical } from '../../..';
import { CheckBox } from '../General/Checkbox';
import { __ } from 'react-i18n';
import { rem } from 'polished';

interface Props {
  handleCheckboxChange: any;
  filters: any;
  isB2B?: boolean;
}

function CategoryFilterCheckboxes({
  handleCheckboxChange,
  filters,
  isB2B,
}: Props) {
  const handleChange = e => {
    const { value, name } = e.target;
    handleCheckboxChange({ name, value });
  };

  return (
    <CheckboxWrapper>
      <CheckBox
        wrapperStyle={{ marginRight: rem(24), marginBottom: rem(16) }}
        label={__('Skladom')}
        type={'checkbox'}
        onClick={handleChange}
        name="onlyAvailable"
        selected={filters.onlyAvailable === '1' ? true : false}
      />
      <CheckBox
        wrapperStyle={{ marginRight: rem(24), marginBottom: rem(16) }}
        label={__('Novinky')}
        type={'checkbox'}
        selected={filters.new === '1' ? true : false}
        onClick={handleChange}
        name="new"
      />
      <CheckBox
        wrapperStyle={{ marginRight: rem(24), marginBottom: rem(16) }}
        label={__('Akcia')}
        type={'checkbox'}
        selected={
          isB2B ? filters.saleB2B === '1' : filters.sale === '1' ? true : false
        }
        onClick={handleChange}
        name={isB2B ? 'saleB2B' : 'sale'}
      />
      <CheckBox
        wrapperStyle={{ marginRight: rem(24), marginBottom: rem(16) }}
        label={__('Výpredaj')}
        type={'checkbox'}
        selected={filters.saleout === '1' ? true : false}
        onClick={handleChange}
        name="saleout"
      />
      {false && (
        <CheckBox
          wrapperStyle={{ marginRight: rem(24), marginBottom: rem(16) }}
          label={__('Mnou objednané')}
          type={'checkbox'}
          selected={filters.ordered === '1' ? true : false}
          onClick={handleChange}
          name="ordered"
        />
      )}
    </CheckboxWrapper>
  );
}

const CheckboxWrapper = styled(FlexRowCenterVertical)`
  margin-left: ${rem(32)};
  flex-flow: row wrap;

  ${({ theme }) => theme.mediab.m760`
    display: block;
    flex-flow: column;
    margin: 0;
    padding: ${rem(24)} ${rem(16)} ${rem(12)};
    align-items: flex-start;
  `}
`;

export { CategoryFilterCheckboxes };
